import 'react-app-polyfill/ie9';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// jQuery must be set up globally BEFORE any DataTables imports
import './jquerySetup';

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import {createStore} from 'redux';
import {Provider} from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { CookiesProvider } from 'react-cookie';

import App from './App';
import * as serviceWorker from './serviceWorker';
import reducer from "./store/reducer";
import './i18n';

const store = createStore(reducer);

ReactDOM.render(
    <Suspense fallback={<div>Loading language...</div>}>
        <Provider store={store}>
            <CookiesProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </CookiesProvider>
        </Provider>
    </Suspense>, document.getElementById('root'));

serviceWorker.unregister();
